/** The largest image that can be added, as the legacy designer allowed. */
export const ImageMaxBytes = 1024000;

export type ImageFileResult = { dataUri: string } | { error: string };

/** The file as a data URI, or why it can't be used. */
export function readImageFile(file: File): Promise<ImageFileResult> {
  if (!file.type.startsWith("image/")) {
    return Promise.resolve({ error: "Only images can be uploaded" });
  }

  if (file.size > ImageMaxBytes) {
    return Promise.resolve({ error: "File can not be larger than 1MB" });
  }

  return new Promise((resolve) => {
    const reader = new FileReader();

    reader.onload = () => resolve({ dataUri: String(reader.result) });
    reader.onerror = () => resolve({ error: "The image could not be read" });
    reader.readAsDataURL(file);
  });
}

/** The image's own size, for fitting it to the space it is placed in. */
export function readImageSize(dataUri: string): Promise<{ width: number; height: number }> {
  return new Promise((resolve, reject) => {
    const image = new Image();

    image.onload = () => resolve({ width: image.width, height: image.height });
    image.onerror = () => reject(new Error("The image could not be read"));
    image.src = dataUri;
  });
}
